import { render } from "./index.vue?vue&type=template&id=06133d6d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=06133d6d&rel=stylesheet%2Fcss&lang=css"
import "./index.vue?vue&type=style&index=1&id=06133d6d&lang=css"
import "./index.vue?vue&type=style&index=2&id=06133d6d&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06133d6d"]])

export default __exports__